import LoginContent from "../components/AuthContent/LoginContent";
import { useContext, useEffect } from "react";
import AuthContext from "../store/auth-context";
import { useNavigate, useLocation } from 'react-router-dom';
import { resolveSafeRedirect, followRedirect } from "../helper/redirect";

const Login = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const authCtx = useContext(AuthContext);

    // The marketing site sends people here with ?redirect=<its own URL> and
    // expects them back once signed in. Only importjdmmagic.com targets are
    // honoured - see helper/redirect.js.
    const redirectParam = new URLSearchParams(location.search).get('redirect');

    useEffect(() => {
        if (authCtx.isLoggedIn && authCtx.userData) {
            const target = resolveSafeRedirect(redirectParam);
            console.log("Login complete - redirecting", target ? `to ${target.url}` : "to dashboard");
            followRedirect(target, navigate, '/');
        }
    }, [authCtx.isLoggedIn, authCtx.userData, navigate, redirectParam]);

    return (
        <>
            <LoginContent/>
        </>
    );
}

export default Login;